import React from 'react'
import AppRoutes from './components/routes/AppRoutes'

function App() {
  return (
    <>
      <AppRoutes/>
    </>
  )
}

export default App